export const STROKE_COLORS = [
  '#FF0000',
  '#00FF00',
  '#0000FF',
  '#FFFF00',
  '#FF00FF',
  '#00FFFF', 
  '#000000',
  '#FFFFFF', 
  '#FFA500', 
  '#800080', 
];

export const STROKE_WIDTH_OPTIONS = [1, 2, 3, 4, 5, 8, 10, 15, 20];

export interface TaskImageEditProps {
  imageFile?: File;
  onSave?: (editedImageBlob: Blob) => void;
  onCancel?: () => void;
  maxWidth?: number;
  maxHeight?: number;
  inModal?: boolean;
}

export interface ImageDimensions {
  width: number;
  height: number;
}

export interface CanvasState {
  canUndo: boolean;
  canRedo: boolean;
  canvasReady: boolean;
  isLoading: boolean;
  error: string | null;
}
